module.exports = __webpack_public_path__ + "img/resume-parser.5dc0a4d0.svg";